var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.getters['ui/httpCode'] === 503)?_c('div',[_c('v-card',[_c('v-card-text',[_vm._v("Access Denied")])],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }